import axios from "axios";
import qs from "qs";


class DCU {
  static getAuth = async () => {
    const clientId = "c1615d5b92c242b2aef31d6a7a676c01";
    const clientSecret = "1b698e0f8fcb48a7971a0919fa2af654";

    const headers = {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/x-www-form-urlencoded"
      },
      auth: {
        username: clientId,
        password: clientSecret
      }
    };
    const data = {
      grant_type: "client_credentials"
    };

    try {
      const response = await axios.post(
        "https://accounts.spotify.com/api/token",
        qs.stringify(data),
        headers
      );
      console.log(response.data.access_token);
      return response.data.access_token;
    } catch (error) {
      console.log(error);
    }
  };

  static getPlaylist = async (token, sku) => {

    var config = {
        method: 'get',
        url: `https://api.spotify.com/v1/playlists/${sku}`,
        headers: {
          'Authorization': `Bearer ${token}`
        }
      };

      const response = await axios(config)
      .then(function (x) {
        //console.log(response.data);
        return x;
      })
      .catch(function (error) {
        console.log(error);
      });

      return response;




  }



}

export default DCU;
